import request from '@/api/request'
//赛季列表
export const getSeasonList = (params) => {
    return request({
        url: '/activity/adm/season/getListPage',
        method: 'get',
        params
    });
}
//新增赛季
export const addSeason = (params) => {
    return request({
        url: '/activity/adm/season/addSeason',
        method: 'post',
        params,
    });
}
//修改赛季
export const updateSeason = (params, queryId) => {
    return request({
        url: `/activity/adm/season/updateSeason?id=${queryId}`,
        method: 'post',
        params
    });
}
//删除赛季
export const delSeason = (params, queryId) => {
    return request({
        url: `/activity/adm/season/delSeason?id=${queryId}`,
        method: 'post',
        params
    });
}
//获取战队列表
export const getTeamList = (params) => {
    return request({
        url: '/activity/adm/seasonTeam/getListPage',
        method: 'get',
        params
    });
}
//新增战队
export const addTeam = (params) => {
    return request({
        url: "/activity/adm/seasonTeam/addSeasonTeam",
        method: "post",
        data: params,
        type: 'json'
    });
}
//更新战队
export const updateTeam = (params) => {
    return request({
        url: '/activity/adm/seasonTeam/updateSeasonTeam',
        method: 'post',
        data: params,
        type: 'json'
    });
}
//解散战队
export const dissolveTeam = (params, queryId) => {
    return request({
        url: `/activity/adm/seasonTeam/updateStatus?id=${queryId}`,
        method: 'post',
        params
    });
}
// 删除战队
export const delTeam = (params, queryId) => {
    return request({
        url: `/activity/adm/seasonTeam/delSeasonTeam?id=${queryId}`,
        method: 'post',
        params
    });
}
//获取战队成员
export const getTeamOfMembers = (params) => {
    return request({
        url: '/activity/adm/seasonTeamSale/getTeamSaleList',
        method: 'get',
        params
    });
}
//获取手机号相关员工信息
export const getTeamMembersInfo = (params) => {
    return request({
        url: '/base/adm/user/getBaseUserByPhone',
        method: 'get',
        params
    });
}
//获取所选战队pk详情（记录）
export const getCurrentTeamPkInfo = (params) => {
    return request({
        url: '/activity/adm/seasonTeamPkRecord/getPkListPage',
        method: 'get',
        params
    })
}
//查询手机号是否在其他战队
export const personIsInOtherTeam = (params) => {
    return request({
        url: '/activity/adm/seasonTeam/getSaleByPhone',
        method: 'get',
        params
    });
}
//战队管理模块-导入战队
export const importTeam = (data) => {
    return request({
        url: '/activity/adm/seasonTeam/importSeasonTeamSale',
        method: 'post',
        upload: true,
        data
    });
}
// 今日PK数据
export const getTodayStatis = (params) => {
    return request({
        url: '/activity/adm/seasonTeamPkStatis/getTodayStatis',
        method: 'get',
        params
    });
}
// 获取可用团队列表
export const getUsableTeamList = (params) => {
    return request({
        url: '/activity/adm/seasonTeam/getUsableTeamList',
        method: 'get',
        params
    });
}
// 管理端添加赛季战队pk
export const addSeasonTeamPk = (data) => {
    return request({
        url: '/activity/adm/seasonTeamPk/addSeasonTeamPk',
        method: 'post',
        data
    });
}
// 赛季 pk组管理列表
export const getListPageForTeam = (params) => {
    return request({
        url: '/activity/adm/seasonTeamPk/getListPage',
        method: 'get',
        params
    });
}
// 分页查询赛季战队pk统计表
export const getListPageForSJ = (params) => {
    return request({
        url: '/activity/adm/seasonTeamPkStatis/getListPage',
        method: 'get',
        params
    });
}
// 战队pk详情
export const getPkListPage = (params) => {
    return request({
        url: '/activity/adm/seasonTeamPkRecord/getPkListPage',
        method: 'get',
        params
    });
}
// 导入PK战队
export const importPk = (data) => {
    return request({
        url: '/activity/adm/seasonTeamPk/importPk',
        method: 'post',
        upload: true,
        data
    });
}
// 获取当前当日赛季
export const getCurrSeasons = (params) => {
    return request({
        url: '/activity/adm/season/getCurrSeasons',
        method: 'get',
        params
    });
}
// 获取所有赛季
export const getAllSeasons = (params) => {
    return request({
        url: '/activity/adm/season/getAllSeasons',
        method: 'get',
        params
    });
}
// 获取通知
export const getNotice = (data) => {
    return request({
        url: '/activity/adm/season/getNotice',
        method: 'post',
        data
    });
}
// 修改通知
export const updateNotice = (data) => {
    return request({
        url: '/activity/adm/season/updateNotice',
        method: 'post',
        data
    });
}